import { useEffect, MutableRefObject } from 'react';

const events = ['mousedown', 'touchstart'] as const;

const useClickOutside = (
  ref: MutableRefObject<HTMLElement | null>,
  onClickOutside: () => void,
): void => {
  const isOutside = (element: EventTarget | null):
  boolean => !ref.current || (element instanceof Node && !ref.current.contains(element));

  const onClick = (event: MouseEvent | TouchEvent): void => {
    if (isOutside(event.target)) {
      onClickOutside();
    }
  };

  useEffect(() => {
    events.forEach((event) => {
      document.addEventListener(event, onClick);
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, onClick);
      });
    };
  });
};

export default useClickOutside;
